import React from "react";

export const rook_filled = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24.001"
        height="24.001"
        viewBox="0 0 24.001 24.001"
    >
        <g id="g2532" transform="translate(-12.237 -7.588)">
            <path
                id="path3097"
                d="M12.237,31.537c0-.2.445-2.748.539-3.085.246-.885.7-1.4,1.918-2.133.7-.425.722-.445.811-.714a24.353,24.353,0,0,0,.661-3.838c.11-.973.64-6.929.618-6.944-.193-.127-1.611-1.135-1.935-1.375a4.006,4.006,0,0,1-.655-.607c-.385-.506-.41-.675-.441-3.037L13.725,7.69h2.1c1.292,0,2.221.023,2.409.059.438.084.491.182.522.952.032.806.1,1.047.355,1.247.239.188.553.241,1.244.208.557-.026.8-.122.977-.388.1-.144.116-.3.133-1.143l.02-.976,2.689-.04c3.043-.045,3.079-.042,3.18.286a2.258,2.258,0,0,1,.064.521,4.406,4.406,0,0,0,.206,1.5c.134.183.382.253.9.253a1.5,1.5,0,0,0,.7-.121c.4-.183.483-.375.532-1.283.045-.848.088-.931.522-1.021.129-.027,1.186-.049,2.349-.05H34.74V9.668c0,1.111-.028,2.129-.063,2.323-.137.758-.388,1.029-2.023,2.184-.856.6-.914.657-.914.827,0,.347.544,6.284.663,7.247a18.107,18.107,0,0,0,.648,3.477,2.9,2.9,0,0,0,.739.571,4.788,4.788,0,0,1,1.445,1.16c.392.537.516.981.792,2.813.085.562.167,1.089.182,1.171l.029.148h-12c-7.693,0-12-.019-12-.052Z"
            />
        </g>
    </svg>
);
